import styled from 'styled-components';
import { color, fontFamily, fontSize } from '../../design-tokens';

export const SheetMusicIcon = styled.div`
  display: flex;
  color: ${color.red100};
  font-family: ${fontFamily.regular};
  font-size: ${fontSize.medium};
`;
